import { writable } from 'svelte/store';

const createShowLogout = () => {
	const { subscribe, set } = writable<'' | 'showModal1Hour' | 'showModal5Minutes' | 'reload'>('');

	let showModal1HourTime: ReturnType<typeof setTimeout>;
	let showModal5MinutesTime: ReturnType<typeof setTimeout>;
	let reloadTime: ReturnType<typeof setTimeout>;

	const setStore = (seconds: number) => {
		if (seconds < 0) return; // If the token is set to 0 Unix time it lasts forever
		if (2147483647 / 1000 <= seconds) return; // The upper limit for setTimeout is 2147483647 milliseconds (a signed 32-bit integer)
		const msUntilLogout = seconds * 1000;
		const oneHour = 60 * 60 * 1000;
		const fiveMins = 5 * 60 * 1000;

		if (showModal1HourTime) clearTimeout(showModal1HourTime);
		if (showModal5MinutesTime) clearTimeout(showModal5MinutesTime);
		if (reloadTime) clearTimeout(reloadTime);

		if (msUntilLogout >= oneHour) {
			showModal1HourTime = setTimeout(() => {
				set('showModal1Hour');
			}, msUntilLogout - oneHour);
		}
		if (msUntilLogout >= fiveMins) {
			showModal5MinutesTime = setTimeout(() => {
				set('showModal5Minutes');
			}, msUntilLogout - fiveMins);
		}

		reloadTime = setTimeout(() => {
			set('reload');
		}, msUntilLogout);
	};

	return {
		subscribe,
		set: setStore,
	};
};

export const showLogoutStore = createShowLogout();
